import { FC } from 'react'
import styles from './footer-socials.module.scss'
import Image from 'next/image'

type FooterSocialsProps = {}

const FooterSocials: FC<FooterSocialsProps> = ({}) => {
  return (
    <div className={styles.socials}>
      <a href="https://vk.com/majordomo_live" className={styles.social} aria-label="vk">
        <Image width={16} height={16} src="/img/icons/vk.svg" alt="vk" title="Логотип ВКонтакте" loading="lazy" />
      </a>
      <a href="https://t.me/majordomo_ru" className={styles.social} aria-label="tg">
        <Image width={16} height={16} src="/img/icons/tg.svg" alt="telegram" title="Логотип Telegram" loading="lazy" />
      </a>
      <a
        href="https://zen.yandex.ru/id/61e95d9bcacc3718a6833a53"
        className={styles.social}
        aria-label="dzen"
      >
        <Image width={16} height={16} src="/img/icons/dzen.svg" alt="dzen" title="Логотип Яндекс.Дзен" loading="lazy" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCKUbH9NxgmjMVytBsVjr4xw"
        className={styles.social}
        aria-label="yt"
      >
        <Image width={16} height={16} src="/img/icons/yt.svg" alt="youtube" title="Логотип YouTube" loading="lazy" />
      </a>
    </div>
  )
}

export default FooterSocials
